/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: LinkFieldPopover.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/29 @ 1333
 * ---
 * Description:
 */

import {Button, MenuItem} from "@blueprintjs/core";
import {Select2} from "@blueprintjs/select";
import {ShapeTypes} from "../../../common/enums";
import {ControlInputChildConnector} from "../../editor/controls/TextBasedControlInput";

export const linkFieldPopoverRenderer = (props: ControlInputChildConnector<string>) => {
    const mlPrecompFeature = props.editor.myLabelPrecompiledFeature;

    return (
        <Select2 filterable={false} items={mlPrecompFeature.getForGroup(ShapeTypes.BARCODE)}
                 itemRenderer={(item, itemProps) => {
                     return <MenuItem text={item.name} onClick={itemProps.handleClick}/>
                 }} onItemSelect={item => props.setFieldValue(item.fieldName)}>
            <Button icon="data-connection" minimal/>
        </Select2>)
}